module.exports = require('./lib');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-highlight/index.js
 ** module id = 356
 ** module chunks = 0
 **/